export default __webpack_public_path__ + "static/media/role-management.5acc44e0.svg";